import { LittleText, Text } from '@/components/common/UI'
import { CalendarData } from '@/types'

export const Schedule = ({
    id,
    date,
    contentBody
}: Partial<CalendarData>): JSX.Element => {
    return (
        <div className="flex content-center gap-3 p-2 overflow-hidden text-center bg-white rounded-lg shadow-2xl w-auto h-auto">
            <div className="flex-shrink-0">
                <Text
                    text={date?.day?.toString() || ''}
                    className="font-bold text-danger"
                />
                <Text
                    text={date?.month || ''}
                    className="font-bold"
                />
            </div>

            <div className="transition-opacity duration-300 opacity-100 text-left">
                <LittleText
                    text={contentBody || ''}
                    className="pt-4"
                />
            </div>
        </div>
    )
}
